// Pricing module routes. Focused IA (2026-05-25): three surfaces only —
//   /pricing                 — Unit Rate Catalogue (tariff browser + EFL)
//   /pricing/rates-overview  — Rates Overview (read; 3-section rate stack)
//   /pricing/config          — Pricing Config (write; 4 admin CRUDs as tabs)
//
// The former standalone pages (Unit Rate Builder, Wholesale Viewer) and the
// per-resource admin routes were retired from navigation; the admin screens
// now live as tabs inside PricingConfigPage. The Builder/Wholesale page files
// are kept dormant (not routed) for easy restore.

import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

const UnitRatePage = lazy(() =>
  import('./pages/UnitRatePage').then((m) => ({ default: m.UnitRatePage })),
);
const RatesOverviewPage = lazy(() =>
  import('./pages/RatesOverviewPage').then((m) => ({ default: m.RatesOverviewPage })),
);
const PricingConfigPage = lazy(() =>
  import('./pages/PricingConfigPage').then((m) => ({ default: m.PricingConfigPage })),
);

export const pricingRoutes: RouteObject[] = [
  { path: '/pricing', element: <UnitRatePage /> },
  { path: '/pricing/rates-overview', element: <RatesOverviewPage /> },
  { path: '/pricing/config', element: <PricingConfigPage /> },
  // The tariff catalogue lived here (and, before that, as the fourth tab of
  // Pricing Config). It is a section of its own now — "Tariff management",
  // `module/tariffs`, at `/tariffs` — because a plan is no longer created
  // straight onto the shelf: it is submitted, approved by a tariff manager,
  // and only then published, and the queue and the managers belong beside
  // the catalogue rather than under Pricing. The path stays as a redirect:
  // it is in bookmarks, in operators' history and in the epic docs.
  { path: '/pricing/tariffs', element: <Navigate to="/tariffs" replace /> },
];
